import _get from 'lodash/get';

export default function createInitialExpandedProductsMap(products = []) {
  return products.reduce((acc, product) => {
    const productId = _get(product, 'ObjectId', '');
    acc[productId] = true;
    return acc;
  }, {});
}
